import swal from 'sweetalert2'

const customStyleClass = 'customSwal'
const customSwal = function () {
  const mixinSwal = swal.mixin({
    title: '',
    text: '',
    customClass: {
      container: customStyleClass
    },
    buttonsStyling: true,
    confirmButtonText: '確認',
    cancelButtonText: '取消',
    allowOutsideClick: false,
    allowEscapeKey: false,
    reverseButtons: true
  })
  const waitCloseLoading = async function () {
    const loader = document.querySelector('.swal2-loader')
    if (loader) loader.style.display = 'none'
    mixinSwal.close()
    await new Promise((resolve) => setTimeout(resolve, 200))
  }
  mixinSwal.simpleLoading = function (title = undefined) {
    if (typeof title === 'boolean' && !title) {
      mixinSwal.close()
      return false
    }
    let containerClass = title ? 'simpleLoading withTitle' : 'simpleLoading'
    containerClass += ` ${customStyleClass}`
    mixinSwal.fire({
      title,
      text: '',
      returnFocus: false,
      customClass: {
        container: containerClass
      },
      didOpen: () => {
        mixinSwal.showLoading()
      }
    })
  }
  mixinSwal.confirm = async function (opt = { title: '', text: '' }) {
    return await mixinSwal
      .fire({
        icon: 'question',
        showCancelButton: true,
        focusCancel: true,
        ...opt
      })
      .then((result) => {
        return result.isConfirmed
      })
  }
  mixinSwal.warningConfirm = async function (opt = { title: '', text: '' }) {
    return mixinSwal
      .fire({
        icon: 'warning',
        showCancelButton: true,
        focusCancel: true,
        ...opt
      })
      .then((result) => {
        return result.isConfirmed
      })
  }
  mixinSwal.input = async function (opt) {
    return await mixinSwal.fire({
      input: 'text',
      showCancelButton: true,
      allowOutsideClick: true,
      allowEscapeKey: true,
      ...opt
    })
  }
  mixinSwal.error = async function (opt = { title: '', text: '' }) {
    await waitCloseLoading()
    return mixinSwal
      .fire({
        ...opt,
        icon: 'error'
      })
      .then((result) => {
        return result.isConfirmed
      })
  }
  mixinSwal.success = async function (opt = { title: '', text: '' }) {
    await waitCloseLoading()
    return mixinSwal.fire({
      timer: 5000,
      ...opt,
      icon: 'success'
    })
  }
  mixinSwal.toast = async function (opt) {
    await waitCloseLoading()
    swal.fire({
      ...opt,
      toast: true,
      icon: 'success',
      position: 'top-end',
      customClass: {
        container: 'toast'
      },
      showConfirmButton: false,
      timer: 3000,
      timerProgressBar: true,
      didOpen: (toast) => {
        toast.addEventListener('mouseenter', swal.stopTimer)
        toast.addEventListener('mouseleave', swal.resumeTimer)
        toast.addEventListener('click', () => {
          swal.close()
          swal.toggleTimer()
        })
      }
    })
  }
  return mixinSwal
}

const mySwal = customSwal()

export default mySwal
